export interface wechatPayType {
  communityId?: string;
  openId?: string;
  orderAmount?: number;
  outTradeNo?: string;
  payType?: string;
  tenantId?: string;
  title?: string;
  userId?: string;
}

export interface wechatRechargePramsType {
  recharge?: string | number;
  accountBalance?: string;
  ownerId?: string;
  primeRate?: number;
}

export enum wechatPayRequestEnum {
  success = 'get_brand_wcpay_request:ok',
  cancel = 'get_brand_wcpay_request:cancel',
  fail = 'get_brand_wcpay_request:fail',
}

export interface CustomerRechargeParamsType {
  accountNo: string;
  changeAmount: number;
  paymentRemark?: string;
  paymentMethod: Array<{ payChannel: string; amount: number }>;
}
